var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7998 14.7077H5.1998C3.87432 14.7077 2.7998 13.6332 2.7998 12.3077V4.30771C2.7998 2.98223 3.87432 1.90771 5.1998 1.90771H10.7998C12.1253 1.90771 13.1998 2.98223 13.1998 4.30771V6.30771M10.3998 5.10771H5.1998M7.9998 7.50771H5.1998M6.7998 9.90771H5.1998M9.1998 10.1077L10.1265 9.64437C10.8022 9.30654 11.5975 9.30654 12.2731 9.64437L13.1998 10.1077C13.1998 10.1077 13.1998 11.5677 13.1998 12.3377C13.1998 13.1077 12.488 13.6275 11.1998 14.441C9.91158 13.6275 9.1998 12.941 9.1998 12.3377V10.1077Z",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgreement);
export default __webpack_public_path__ + "static/media/IconAgreement.85f48e683047f6f2ec341471d4172f5e.svg";
export { ForwardRef as ReactComponent };